export default __webpack_public_path__ + "static/media/logo-wordmark-white.441a8220.svg";